<template>
  <div>
  </div>
</template>

<script>
import {loadLoginStatus, setSessionData} from "../utils/cache";
import HttpRequest from "@/utils/request";
import {mapState} from "vuex";
import {getFrameMenus} from "@/assets/js/consult";

export default {
  data() {
    return {
      ticket: null,
      partner: null
    };
  },
  created() {
    this.casLogin();
  },
  computed: {
    ...mapState({
      student: state => state.user.student,
      admin: state => state.user.admin
    })
  },
  methods: {
    getAdmin(partner, token, name, degree) {
      let url = "/constub/gainAdminMenu";
      HttpRequest.requestFormPost(url, {partner: partner, token: token}).then((res) => {
        let admin = res.data
        store.dispatch('setAdmin', admin)
        let consult_SmartPavilion = admin.jsonSetting.consult_SmartPavilion
        let menus = getFrameMenus(consult_SmartPavilion, "")
        let r = menus[0].index
        if (name && degree)
          this.$router.push('/' + r + '?partner=' + partner);
        else {
          this.$alert('首次登录，请先填写个人资料', {
            showClose: false,
            confirmButtonText: '继续',
            callback: action => {
              this.$router.push('/firstPersonalData?pathfrom=' + r);
            }
          });
        }
      });
    },
    casLogin() {
      let loginStatus = loadLoginStatus();
      this.ticket = this.$route.query.ticket;
      this.partner = this.$route.query.partner;

      if (loginStatus === 0 && this.ticket !== null && this.ticket !== undefined && this.ticket !== "" && this.partner !== undefined) {
        this.login(this.ticket, this.partner);

      } else if (this.ticket == null || this.ticket == undefined || this.ticket === "") {
        //this.questCode == 'ennea'
        if ('23hnnu' === this.partner) {
          window.open('http://211.70.177.57/cas/login?service=http://consult.rennengda.com/constu/casLogin?partner=' + this.partner, '_self');
        } else if ('23jxcfs' === this.partner) {
          window.open('https://cas.jxcfs.com/lyuapServer/login?service=http://consult.rennengda.com/constu/casLogin?partner=' + this.partner, '_self');
        }
      } else if (loadLoginStatus == 1 && student !== null) {
        if (student.studentName && student.studentDegree) {
          let consult_SmartPavilion = this.admin.jsonSetting.consult_SmartPavilion
          let menus = getFrameMenus(consult_SmartPavilion, "")
          let r = menus[0].index
          this.$router.push('/' + r + '?partner=' + this.partner);
        } else {
          this.$alert("首次登录，请先填写个人资料", {
            showClose: false,
            confirmButtonText: "继续",
            callback: action => {
              this.$router.push("/firstPersonalData?pathfrom=home");
            }
          });
        }
      }
    },
    login(ticket, partner) {
      let data = {
        partner: partner,
        ticket: ticket
      };
      let url = "";
      if ('23hnnu' === this.partner) {
        url = "/constub/cas/client/hnnusso";
      } else if ('23jxcfs' === this.partner) {
        url = "/constub/cas/client/jxcfssso";
      }
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          setSessionData("partner", this.partner)
          store.dispatch("setStudent", res.data);
          store.dispatch("setLoginStatus", 1);
          console.log(res.data.studentName && res.data.studentDegree);
          this.getAdmin(partner, res.data.token, res.data.studentName, res.data.studentDegree)
        } else {
          this.$alert(res.result.message, {
            confirmButtonText: "确定",
            showClose: false
          });
        }
      });
    }
  }
};
</script>

<style></style>
